import { Injectable } from '@angular/core'
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpContextToken,
} from '@angular/common/http'
import { Observable } from 'rxjs'
import { finalize } from 'rxjs/operators'
import { LoadingSpinnerService } from 'src/app/public/spinner/loading-spinner.service'

export const GLOBAL_LOADING_SPINNER_ENABLED = new HttpContextToken<boolean>(
  () => true,
)

@Injectable()
export class LoadingSpinnerInterceptor implements HttpInterceptor {
  constructor(public spinnerService: LoadingSpinnerService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    if (request.context.get(GLOBAL_LOADING_SPINNER_ENABLED)) {
      this.spinnerService.handleRequest('plus')
      return next.handle(request).pipe(finalize(this.finalize))
    } else {
      return next.handle(request)
    }
  }

  private finalize = () => {
    this.spinnerService.handleRequest('minus')
  }
}
